import { lazy } from 'react';
import type { ViewKey } from '@platform/core/types';
import type { ViewComponent } from './ViewComponent';

const registry = new Map<string, ViewComponent>();

/** Реєстр представлень: стандартні — вбудовані, кастомні — лениві чанки (06-Frontend/component-registry.md §2). */
export function registerView(key: string, component: ViewComponent): void {
  registry.set(key, component);
}

export function resolveView(key: ViewKey): ViewComponent {
  return registry.get(key) ?? registry.get('__custom__')!;
}

export function hasView(key: string): boolean {
  return registry.has(key);
}

registerView('table', lazy(() => import('../views/TableView').then((m) => ({ default: m.TableView }))));
registerView('stages', lazy(() => import('../views/StagesView').then((m) => ({ default: m.StagesView }))));
registerView('cards', lazy(() => import('../views/CardsView').then((m) => ({ default: m.CardsView }))));
registerView('inline', lazy(() => import('../views/InlineView').then((m) => ({ default: m.InlineView }))));
registerView('backlog', lazy(() => import('../views/BoardView').then((m) => ({ default: m.BoardView }))));
registerView('split', lazy(() => import('../views/SplitView').then((m) => ({ default: m.SplitView }))));
registerView('calendar', lazy(() => import('../views/CalendarView').then((m) => ({ default: m.CalendarView }))));
registerView('dashboard', lazy(() => import('../views/DashboardView').then((m) => ({ default: m.DashboardView }))));
registerView('__custom__', lazy(() => import('../views/CustomViewPlaceholder').then((m) => ({ default: m.CustomViewPlaceholder }))));
